import { render, staticRenderFns } from "./chooseTemplateList.vue?vue&type=template&id=228a6b00&scoped=true"
import script from "./chooseTemplateList.vue?vue&type=script&lang=js"
export * from "./chooseTemplateList.vue?vue&type=script&lang=js"
import style0 from "./chooseTemplateList.vue?vue&type=style&index=0&id=228a6b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a6b00",
  null
  
)

export default component.exports